/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Mathematics22Inputs */

const en__field_enum_csjensblank_mathematics22 = /** @type {(inputs: _Field_Enum_Csjensblank_Mathematics22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural Sciences & Mathematics`)
};

const de__field_enum_csjensblank_mathematics22 = /** @type {(inputs: _Field_Enum_Csjensblank_Mathematics22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturwissenschaften & Mathematik`)
};

/**
* | output |
* | --- |
* | "Natural Sciences & Mathematics" |
*
* @param {_Field_Enum_Csjensblank_Mathematics22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_mathematics22 = /** @type {((inputs?: _Field_Enum_Csjensblank_Mathematics22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Mathematics22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_mathematics22(inputs)
	return de__field_enum_csjensblank_mathematics22(inputs)
});
export { _field_enum_csjensblank_mathematics22 as "_field_enum_CSJENSBLANK_MATHEMATICS" }